import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import {imgSize} from "../../../../config/values";
import FolderIcon from '@material-ui/icons/Folder';
import Button from "@material-ui/core/Button/Button";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {setStore} from "trim-redux";
import AddDirectoryButton from "./AddDirectoryButton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs/Breadcrumbs";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import FilesDirectoryManager from "./FilesDirectoryManager";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LoadingButton from "../../../components/elements/LoadingButton";
class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state = {
        loading:true,
        SubmitLoading:false,
        directories:[],
        current_directory:null
    }

    classes = this.props.classes;
    handleCurrentDirectory(current_directory){
        this.setState({
            current_directory
        })
    }
    async handleRequest(){
        await this.setState({
            SubmitLoading:true,
        });
        const {current_directory} = this.state;
        const {items} = this.props;
        let ids = [];
        await items.map(item => {
            ids.push(item.id)
        })
        let data = new FormData();
        await data.append('current_directory', current_directory);
        await data.append('ids', JSON.stringify(ids));
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/change-directory`, data, config)
            .then(response => {
                this.setState({
                    SubmitLoading:false,
                    open:false,
                });
                this.props.reload();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                });
            });
    }
    render(){
        let {directories,loading,SubmitLoading} = this.state;
        return(
            <>
                <Dialog open={true} fullWidth maxWidth="sm">
                    <DialogTitle id="form-dialog-title">
                        {Translate.moveFilesToDirectory}
                        <IconButton aria-label="close" className="modal-close-btn"  onClick={() => this.props.hanleClose()}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <FilesDirectoryManager
                            handleCurrentDirectory={this.handleCurrentDirectory.bind(this)}
                            move
                        />
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            onClick = {this.handleRequest.bind(this)}
                            loading = {SubmitLoading}
                        >
                            {Translate.moveHere}
                        </LoadingButton>
                    </DialogContent>
                </Dialog>

            </>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);